export default __webpack_public_path__ + "static/media/demo.528a92c2.png";